import { render } from "./CaisseNationalPage.vue?vue&type=template&id=6b8daaa6"
import script from "./CaisseNationalPage.vue?vue&type=script&lang=js"
export * from "./CaisseNationalPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__